/**
 * @ngdoc directive
 * @name gazelle.components.gettingStarted.directive:gzStart
 *
 * @description
 *
 * @example
 */

export const name = 'gzStart';
export default function gzStart() {
  //noinspection BadExpressionStatementJS
  'ngInject';

  let directive = {
    restrict: 'E',
    transclude: true,
    scope: {
      gzStepSettings: '=',
      gzIsStarting: '=?',
      gzPairingId: '@'
    },
    template: require('./getting-started.jade'),
    controllerAs: 'vm',
    bindToController: true,
    controller: gzStartController
  };

  return directive;

  /////////////////

  // @ngInject
  function gzStartController(
    $translate,
    $q,
    $window,
    rnClient,
    rnPreferences,
    $gzAnalytics
  ) {

    let api = {
      test: test,
      resetAll: resetAll,
      evaluateSteps: evaluateSteps
    };
    let clientConfig;
    let preferences;
    let currentPath;

    let vm = this;
    vm.loading = true;
    vm.mySteps = [];

    vm.back = back;
    vm.next = next;
    vm.selectStep = selectStep;
    vm.reload = reload;

    vm.unitTest = {
      determineInclude,
      determineComplete,
      setPreferences(p) {
        preferences = p;
      },
      setCurrentPath(c) {
        currentPath = c;
      }
    };

    vm.$onInit = onInit;

    ////////////////
    function onInit() {
      let promises = [];
      promises.push($translate.onReady());
      promises.push(getClientConfig());
      promises.push(determineInclude());
      $q.all(promises).then(() => {
        configureAPI();
        // Quick short circuit if we've already determined all steps are complete
        if (stepsComplete()) {
          vm.gzIsStarting = false;
          return;
        }

        return initSteps().finally(() => {
          // After evaluation we may determine that all the steps are complete
          vm.gzIsStarting = !stepsComplete();
          vm.loading = false;
        });
      })
        .finally(() => {
          let onLoadCallback = _.get(vm.gzStepSettings, 'callbacks.onLoad');
          if (onLoadCallback) {
            onLoadCallback();
          }

          vm.loading = false;
        });
    }

    function configureAPI() {
      _.set(vm.gzStepSettings, 'state.isLoaded', true);
      _.set(vm.gzStepSettings, 'api', api);
    }

    function getClientConfig() {
      return rnClient.getConfig('gazelle', 'gettingStarted').then(config => {
        clientConfig = config;
        return rnPreferences.getSingleObject('gazelle', 'gettingStarted').then(prefs => {
          preferences = prefs ? prefs : {};
          currentPath = vm.gzPairingId + '.' + config.context.id;
          let currentPreference = _.get(preferences, currentPath);
          if (!currentPreference) {
            let newPrefs = {
              isComplete: false,
              skippedSteps: []
            };
            _.set(preferences, currentPath, newPrefs);
            rnPreferences.setSingleObject('gazelle', 'gettingStarted', preferences);
          }
        });
      });
    }

    function initSteps() {
      return determineComplete().then(() => {
        _.forEach(vm.gzStepSettings.steps, step => {
          if (step.isIncluded) {
            vm.mySteps.push(step);
          }
        });

        let found = _.find(vm.mySteps, '{id: "GZ_FINISH_STEP"}');
        if (!found) {
          vm.mySteps.push({
            id: 'GZ_FINISH_STEP',
            // titleKey: '',
            titleKey: 'uxf.uxf.Finish_Title',
            completeDescriptionKey: 'uxf.uxf.Finish_Description',
            completeDetailsKey: 'uxf.uxf.Finish_Details',
            isOptional: false,
            isIncluded: true,
            isComplete: false,
          });
        }

        vm.selectedIndex = 0;
        _.forEach(vm.mySteps, step => {
          if (step.isComplete) {
            vm.selectedIndex++;
          }
          else {
            return false;
          }
        });

        vm.currentStepIndex = vm.selectedIndex;
        vm.gzStepSettings.currentStep = vm.mySteps[vm.selectedIndex];
        if (vm.gzStepSettings.currentStep.id === 'GZ_FINISH_STEP') {
          //Once they advance to finish we'll automatically check it for them
          vm.gzStepSettings.currentStep.isComplete = true;
          finishSteps();
        }
      });
    }

    function stepsComplete() {
      return _.get(preferences, currentPath + '.isComplete', false);
    }

    function isStepSkipped(step) {
      let skippedSteps = _.get(preferences, currentPath + '.skippedSteps', []);
      return skippedSteps.indexOf(step.id) >= 0;
    }

    function skipStep(step) {
      let skippedSteps = _.get(preferences, currentPath + '.skippedSteps');
      if (skippedSteps.indexOf(step.id) < 0) {
        skippedSteps.push(step.id);
      }

      rnPreferences.setSingleObject('gazelle', 'gettingStarted', preferences);
    }

    function finishSteps() {
      _.set(preferences, currentPath + '.isComplete', true);
      rnPreferences.setSingleObject('gazelle', 'gettingStarted', preferences);
    }

    function determineInclude() {
      let promises = [];
      _.forEach(vm.gzStepSettings.steps, step => {
        let stepSpecificCallback = _.get(step, 'callbacks.isStepIncluded');
        if (stepSpecificCallback) {
          promises.push(stepSpecificCallback(step).then(isIncluded => {
            step.isIncluded = isIncluded;
          }));
        }
        else {
          let generalCallback = _.get(vm.gzStepSettings, 'callbacks.isStepIncluded');
          if (generalCallback) {
            promises.push(generalCallback(step).then(isIncluded => {
              step.isIncluded = isIncluded;
            }));
          }
          else {
            step.isIncluded = false;
          }
        }
      });

      return $q.all(promises);
    }

    function determineComplete() {
      let promises = [];
      _.forEach(vm.gzStepSettings.steps, step => {
        if (step.isIncluded) {
          if (step.isOptional) {
            if (isStepSkipped(step)) {
              step.isComplete = true;
              return;
            }
          }

          let stepSpecificCallback = _.get(step, 'callbacks.isStepComplete');
          if (stepSpecificCallback) {
            promises.push(stepSpecificCallback(step).then(isComplete => {
              step.isComplete = isComplete;
            }));
          }
          else {
            let generalCallback = _.get(vm.gzStepSettings, 'callbacks.isStepComplete');
            if (generalCallback) {
              promises.push(generalCallback(step).then(isComplete => {
                step.isComplete = isComplete;
              }));
            }
            else {
              step.isComplete = false;
            }
          }
        }
      });

      return $q.all(promises);
    }

    function selectStep(index, clicked = true) {
      if (index <= vm.currentStepIndex) {
        vm.selectedIndex = index;
        vm.gzStepSettings.currentStep = vm.mySteps[index];
      }
      let message = `Getting Started - ${vm.gzPairingId}`;
      if (clicked) {
        message = `Click: ${message}`;
      }
      $gzAnalytics.event(message, {label: `step: ${vm.mySteps[index].id}`});
    }

    function back() {
      if (vm.selectedIndex > 0) {
        vm.selectedIndex--;
        vm.gzStepSettings.currentStep = vm.mySteps[vm.selectedIndex];
      }
      $gzAnalytics.eventClick('back button on start directive');
    }

    function next() {
      if (vm.gzStepSettings.currentStep.isOptional) {
        if (!vm.gzStepSettings.currentStep.isComplete) {
          vm.gzStepSettings.currentStep.isComplete = true;
          skipStep(vm.gzStepSettings.currentStep);
        }
      }

      vm.selectedIndex++;
      vm.gzStepSettings.currentStep = vm.mySteps[vm.selectedIndex];
      if (vm.selectedIndex > vm.currentStepIndex) {
        vm.currentStepIndex++;
      }

      if (vm.gzStepSettings.currentStep.id === 'GZ_FINISH_STEP') {
        //Once they advance to finish we'll automatically check it for them
        vm.gzStepSettings.currentStep.isComplete = true;
        finishSteps();
      }

      $gzAnalytics.eventClick('next button on start directive');
    }

    function reload() {
      $window.location.reload();
    }

    function test() {
      alert('This message comes calling a test method in the getting started API');
    }

    function resetAll() {
      if (_.get(preferences, currentPath)) {
        delete preferences[vm.gzPairingId][clientConfig.context.id];
      }

      return rnPreferences.setSingleObject('gazelle', 'gettingStarted', preferences);
    }

    function evaluateSteps(step) {
      return initSteps();
    }
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/extensions/getting-started/getting-started.directive.js